import _ from "underscore";
import { getServerDate } from "../../utils/storage/date";
import { MobileActions } from "../../store/mobile/actions";
import pageHTML from "./gps.tmpl";
import DebugPageView from "./debugPageView";

    export default class GpsView extends DebugPageView {
        private readonly template = _.template(pageHTML);
        private readonly drivingLogs: any[] = [];
        private readonly movement;
        private renderInterval: any = null;

        constructor(options) {
            super(options);
            this.movement = options.app.manager.movement;

            this.storeUnsubscribe = this.app.observeStore(state => [state.mobile.lastPosition, state.data.driving], this.storeListener.bind(this));

            //Set for the gpsSpeedAverage rendering
            this.renderInterval = setInterval(() => {
                let avgSpeedElement = <HTMLSpanElement>document.getElementById("avgSpeed");
                if (avgSpeedElement) {
                    avgSpeedElement.textContent = this.movement.getAverage().toFixed(2);
                }
            }, 3000);
        }

        render () {
            let positions = this.movement.positions.getData();
            let length = positions.length;

            this.el.innerHTML = this.template({
                gpsLogs: positions.slice(length - 100, length),
                drivingLogs: this.drivingLogs
            });

            this.app.store.dispatch(MobileActions.setPageState({
                title: "GPS Debug",
                pageLevel: 2
            }));

            return this;
        }

        storeListener() {
            let date = getServerDate();
            let isDriving = this.app.store.getState().data.driving;
            this.drivingLogs.unshift({
                timestamp: date.toLocaleTimeString(),
                isDriving: typeof (isDriving) === "undefined" ? "Unknown" : isDriving
            });
            this.render();
        }

        remove() {
            window.clearInterval(this.renderInterval);
            this.renderInterval = null;
            super.remove();
            return this;
        }
    }